import { TDatabaseId } from '@infotech-soe/metaschema';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { ConfirmationType } from '../../../models/confirmation/ConfirmationEntity';
import { ConfirmationMessageType } from '../../../services/commands/UserInteractor';
import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import { getHierarchyStateEntity } from '../../../store/selectors/hierarchy';
import confirmation from '../../../store/slices/confirmation';
import hierarchy from '../../../store/slices/hierarchy';

import HierarchyTree from './HierarchyTree';

interface Props {
  treeId: UniqueId;
  title?: string;
  onSelect?: (id: TDatabaseId) => void;
}

const mapStateToProps = (state: AppState, { treeId }: Props) => ({
  tree: getHierarchyStateEntity(state, treeId),
});

const mapDispatchToProps = {
  toggleCheck: hierarchy.toggleCheck,
  clearChecked: hierarchy.clearChecked,
  collapseNode: hierarchy.collapseNode,
  expandNode: hierarchy.expandNode,
  nextNode: hierarchy.nextNode,
  prevNode: hierarchy.prevNode,
  refresh: hierarchy.refresh,
  selectNode: hierarchy.selectNode,
  setHierarchyRoot: hierarchy.setHierarchyRoot,
  move: hierarchy.move,
  showConfirmation: confirmation.show,
};

const mergeProps = (
  sP: ReturnType<typeof mapStateToProps>,
  {
    toggleCheck,
    clearChecked,
    collapseNode,
    expandNode,
    nextNode,
    prevNode,
    refresh,
    selectNode,
    setHierarchyRoot,
    move,
    showConfirmation,
  }: typeof mapDispatchToProps,
  { treeId: categoryId, onSelect: onSelectProp, ...oP }: Props
) => ({
  ...sP,
  ...oP,
  onCheckToggle: (nodeId?: TDatabaseId, shift?: boolean) =>
    toggleCheck({ categoryId, nodeId, shift }),
  onClearChecked: () => clearChecked({ categoryId }),
  onCollapse: (nodeId?: TDatabaseId) => collapseNode({ categoryId, nodeId }),
  onExpand: (nodeId?: TDatabaseId) => expandNode({ categoryId, nodeId }),
  onNext: () => nextNode({ categoryId }),
  onPrev: () => prevNode({ categoryId }),
  onRefresh: (loadPathToNode?: TDatabaseId) =>
    refresh({ categoryId, loadPathToNode }),
  onSelect: (nodeId: TDatabaseId) => {
    onSelectProp?.(nodeId);
    selectNode({ categoryId, nodeId });
  },
  onSetHierarchy: (nodeId?: TDatabaseId) =>
    setHierarchyRoot({ categoryId, nodeId }),
  onMove: (moveIds: TDatabaseId[], newParentId: TDatabaseId) =>
    move({ categoryId, moveIds, newParentId }),
  onShowConfirmation: (moveIds: TDatabaseId[], newParentId: TDatabaseId) =>
    showConfirmation({
      type: ConfirmationType.HIERARCHY,
      action: {
        command: ConfirmationMessageType.MOVE_HIERARCHY,
        args: { treeId: categoryId, nodeId: moveIds, parentId: newParentId },
        hook: false,
      },
      messageType: ConfirmationMessageType.MOVE_HIERARCHY,
    }),
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type HierarchyTreeConnectorProps = ConnectedProps<typeof connector>;

export default connector(HierarchyTree);
